<template>
  <div class="wrapper">
      <div class="banner">
        <img src="../../image/logo/admin_banner.png" alt=""/>
      </div>
  </div>
</template>

<script>
import "../../assets/icons/iconfont.css";
export default {
  components: {},
  props: {},
  data() {
    return {
      loginCompanyType:"",
    };
  },
  watch: {},
  computed: {},
  methods: {},
  created() {},
  mounted() {
    this.loginCompanyType=window.sessionStorage.getItem("loginCompanyType")
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  padding: 0;
  .banner {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/user/homeindex.vue